import React, { useState } from "react";
import "./Transport.css";
import logo from "../../Asset/Yashavi.png";
import TransportTrucks from "../../Asset/Transport.png";
import { submitProductEnquiry } from "../../api";
import toast, { Toaster } from "react-hot-toast";

// ================= HEADER =================
function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const closeMenu = () => setMenuOpen(false);

  return (
    <header className="yt-tms-header">
      <div className="yt-tms-logo-area">
        <div><img src={logo} alt="Yashvitech Logo" /></div>
      </div>

      <nav className={`yt-tms-nav-menu ${menuOpen ? "yt-tms-menu-open" : ""}`}>
        <a href="#features" onClick={closeMenu}>Key Features</a>
        <a href="#demo" onClick={closeMenu}>Interactive Demo</a>
        <a href="#stories" onClick={closeMenu}>Success Stories</a>
        <a href="#faq" onClick={closeMenu}>FAQ</a>
        <a href="#Book" className="yt-tms-demo-btn yt-tms-mobile-only" onClick={closeMenu}>Book Free Demo</a>
      </nav>

      <div className="yt-tms-header-right">
        <div className="yt-tms-phone">☎ <span>+91 98765 43210</span></div>
        <a href="#Book" className="yt-tms-demo-btn yt-tms-desktop-only">Book Free Demo</a>
      </div>

      <div className={`yt-tms-hamburger ${menuOpen ? "yt-tms-hamburger-active" : ""}`} onClick={() => setMenuOpen(!menuOpen)}>
        <span></span><span></span><span></span>
      </div>
    </header>
  );
}

// ================= HOME =================
function Home() {
  return (
    <section id="home" className="yt-tms-home">
      <div className="yt-tms-home-top">
        <div className="yt-tms-home-left">
          <div className="yt-tms-badge">🚚 #1 Transport & Fleet Management Software in India</div>
          <h1>Transform Fleet<br />Operations & Stop Profit<br />Leakage with<span> Yashvitech TMS</span></h1>
          <p>A powerful cloud-based Transport Management System designed for transporters, fleet owners and logistics businesses.</p>
          <div className="yt-tms-home-buttons">
            <button>Book Free Demo →</button>
            <button>Explore Features</button>
          </div>
        </div>
        <div className="yt-tms-home-right"><img src={TransportTrucks} alt="Transport Trucks" /></div>
      </div>

      <div className="yt-tms-home-stats">
        <div><h2>500+</h2><p>Fleets Managed</p></div>
        <div><h2>10M+</h2><p>Bilties Generated</p></div>
        <div><h2>99.9%</h2><p>Uptime</p></div>
      </div>

      <div className="yt-tms-trusted">
        <p>TRUSTED BY 500+ LOGISTICS OPERATORS, FLEET OWNERS & GOODS TRANSPORT COMPANIES</p>
        <div className="yt-tms-companies">
          <h3>▣ Apex Express Logistics</h3>
          <h3>▰ SpeedCargo Roadlines</h3>
          <h3>▤ Global Freight Corp</h3>
          <h3>▥ National Transporters</h3>
          <h3>♧ Royal Logistics India</h3>
        </div>
      </div>
    </section>
  );
}

// ================= FEATURES =================
function Features() {
  const [activeTab, setActiveTab] = useState("Operations & Dispatch");

  const featureData = {
    "Operations & Dispatch": [
      { icon: "🏢", title: "Manage Multiple Companies", desc: "Manage multiple companies, branches and transport operations from one platform." },
      { icon: "👥", title: "Customer & Consignor Master", desc: "Maintain complete customer and consignor information in one place." },
      { icon: "📍", title: "Order Booking & Dispatch", desc: "Create orders, assign vehicles and manage dispatch operations easily." },
    ],
    "Accounts & Bilty": [
      { icon: "🧾", title: "Bilty Management", desc: "Create and manage digital bilty records quickly and efficiently." },
      { icon: "💰", title: "Accounts Management", desc: "Track income, expenses, payments and outstanding balances." },
      { icon: "📊", title: "Financial Reports", desc: "Get detailed reports for your complete transport business." },
    ],
    "Diesel, Tyre & Repairs": [
      { icon: "⛽", title: "Diesel Management", desc: "Track diesel usage, fuel expenses and vehicle-wise consumption." },
      { icon: "🛞", title: "Tyre Management", desc: "Monitor tyre usage, replacement and maintenance records." },
      { icon: "🔧", title: "Repair & Maintenance", desc: "Manage vehicle servicing, repairs and maintenance schedules." },
    ],
    "Driver & Document Alerts": [
      { icon: "🚚", title: "Driver Management", desc: "Maintain driver details, assignments and performance records." },
      { icon: "📄", title: "Document Management", desc: "Keep vehicle and driver documents organized in one place." },
      { icon: "🔔", title: "Expiry Alerts", desc: "Get timely alerts for licence, insurance, permit and document expiry." },
    ],
  };

  return (
    <section className="yt-tms-features" id="features">
      <div className="yt-tms-features-heading">
        <div className="yt-tms-feature-badge">COMPLETE LOGISTICS STACK</div>
        <h1>Every Feature You Need to Run a Profitable<br />Transport Business</h1>
        <p>Replaces manual registers, Excel spreadsheets, and fragmented software with one end-to-end cloud platform.</p>
      </div>

      <div className="yt-tms-feature-tabs">
        {Object.keys(featureData).map((tab) => (
          <button key={tab} className={activeTab === tab ? "yt-tms-active-tab" : ""} onClick={() => setActiveTab(tab)}>{tab}</button>
        ))}
      </div>

      <div className="yt-tms-feature-cards">
        {featureData[activeTab].map((item, index) => (
          <div className="yt-tms-feature-card" key={index}>
            <div className="yt-tms-feature-icon">{item.icon}</div>
            <h2>{item.title}</h2>
            <p>{item.desc}</p>
          </div>
        ))}
      </div>

      <div className="yt-tms-whatsapp-button">☎</div>
    </section>
  );
}

// ================= INTERACTIVE DEMO =================
function InteractiveDemo() {
  const [activeModule, setActiveModule] = useState("Bilty Generator");

  const moduleData = {
    "Bilty Generator": {
      icon: "📄", title: "New Lorry Receipt / Bilty #LR-2026-8902", company: "Yashvitech Roadlines Ltd.", date: "19-Aug-2026",
      leftTitle: "CONSIGNER (SENDER)", leftName: "Reliance Industries Ltd.", leftGst: "GST: 27AAAAA0000A1Z5", leftHub: "Hub: Hazira, Gujarat",
      middleTitle: "CONSIGNEE (RECEIVER)", middleName: "Tata Motors Auto Hub", middleGst: "GST: 27BBBBB1111B2Z9", middleHub: "Hub: Chakan, Pune",
      rightTitle: "TRUCK & FREIGHT DETAILS", rightVehicle: "MH-12-VT-9821", rightDriver: "Driver: Ramesh Kumar (DL Valid)", rightAmount: "Freight Amount: ₹ 48,500",
    },
    "Fleet Dispatch Board": {
      icon: "🚚", title: "Fleet Dispatch Board", company: "Yashvitech Roadlines Ltd.", date: "19-Aug-2026",
      leftTitle: "AVAILABLE TRUCKS", leftName: "MH-12-AB-4521", leftGst: "Driver: Amit Kumar", leftHub: "Hub: Pune",
      middleTitle: "IN TRANSIT", middleName: "MH-14-CD-7821", middleGst: "Driver: Rahul Singh", middleHub: "Mumbai → Delhi",
      rightTitle: "DISPATCH STATUS", rightVehicle: "MH-15-XY-8821", rightDriver: "Driver: Suresh Yadav", rightAmount: "Status: On Route",
    },
    "Diesel & Tyre Log": {
      icon: "⛽", title: "Diesel & Tyre Log", company: "Yashvitech Roadlines Ltd.", date: "19-Aug-2026",
      leftTitle: "DIESEL ENTRY", leftName: "MH-12-VT-9821", leftGst: "Fuel: Diesel", leftHub: "120 Litres",
      middleTitle: "TYRE DETAILS", middleName: "Front Left Tyre", middleGst: "Brand: MRF", middleHub: "Good Condition",
      rightTitle: "TOTAL EXPENSE", rightVehicle: "Diesel Cost", rightDriver: "₹ 10,800", rightAmount: "Tyre Cost: ₹ 7,500",
    },
    "Vehicle P&L Report": {
      icon: "📈", title: "Vehicle Profit & Loss Report", company: "Yashvitech Roadlines Ltd.", date: "19-Aug-2026",
      leftTitle: "TOTAL REVENUE", leftName: "MH-12-VT-9821", leftGst: "Freight Revenue", leftHub: "₹ 48,500",
      middleTitle: "TOTAL EXPENSE", middleName: "Fuel + Repair", middleGst: "Operating Cost", middleHub: "₹ 21,400",
      rightTitle: "NET PROFIT", rightVehicle: "Vehicle Profit", rightDriver: "₹ 27,100", rightAmount: "56% Margin",
    },
  };

  const data = moduleData[activeModule];

  return (
    <section className="yt-tms-interactive-demo" id="demo">
      <div className="yt-tms-demo-heading">
        <div className="yt-tms-demo-badge">INTERACTIVE PREVIEW</div>
        <h1>Experience Yashvitech TMS in Action</h1>
        <p>Click the modules below to see how easy it is to manage your transport business.</p>
      </div>

      <div className="yt-tms-demo-tabs">
        {Object.keys(moduleData).map((module) => (
          <button key={module} className={activeModule === module ? "yt-tms-demo-tab yt-tms-active" : "yt-tms-demo-tab"} onClick={() => setActiveModule(module)}>
            <span className="yt-tms-tab-icon">
              {module === "Bilty Generator" && "📄"}
              {module === "Fleet Dispatch Board" && "🚚"}
              {module === "Diesel & Tyre Log" && "⛽"}
              {module === "Vehicle P&L Report" && "📈"}
            </span>
            <span>{module}</span>
          </button>
        ))}
      </div>

      <div className="yt-tms-bilty-preview">
        <div className="yt-tms-bilty-header">
          <div><h2>{data.icon} {data.title}</h2><p>Company: {data.company} | Date: {data.date}</p></div>
          <span className="yt-tms-ready-status">Ready to Print</span>
        </div>
        <div className="yt-tms-bilty-line"></div>
        <div className="yt-tms-bilty-details">
          <div className="yt-tms-bilty-box"><h4>{data.leftTitle}</h4><strong>{data.leftName}</strong><p>{data.leftGst}</p><p>{data.leftHub}</p></div>
          <div className="yt-tms-bilty-box"><h4>{data.middleTitle}</h4><strong>{data.middleName}</strong><p>{data.middleGst}</p><p>{data.middleHub}</p></div>
          <div className="yt-tms-bilty-box"><h4>{data.rightTitle}</h4><p>Vehicle: <strong>{data.rightVehicle}</strong></p><p>{data.rightDriver}</p><strong className="yt-tms-amount">{data.rightAmount}</strong></div>
        </div>
        <div className="yt-tms-preview-bottom">
          <span>✓ Verified Information</span>
          <span>Digital Record</span>
          <button>Print Preview</button>
        </div>
      </div>

      <div className="yt-tms-demo-whatsapp">☎</div>
    </section>
  );
}

// ================= SUCCESS STORIES =================
function SuccessStories() {
  const reviews = [
    { text: "Earlier, generating 50+ bilties every day and reconciling driver advances was a nightmare. Yashvitech TMS automated our entire dispatch. Driver DL alerts alone saved us thousands in RTO fines.", name: "Rajesh Patel", role: "Managing Director, Gujarat Roadlines", company: "65 Truck Fleet", image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?auto=format&fit=crop&w=500&q=80", result: "Faster Dispatch & Fewer RTO Issues", number: "40%", label: "Faster Daily Operations" },
    { text: "The Truck Profit & Loss report feature is a game-changer. I can instantly see which route and which truck is giving us profits versus losses. Diesel tracking eliminated theft completely.", name: "Suresh Khatri", role: "Owner, SpeedCargo Logistics", company: "110 Vehicle Fleet", image: "https://images.unsplash.com/photo-1560250097-0b93528c3070?auto=format&fit=crop&w=500&q=80", result: "Better Profit & Expense Control", number: "25%", label: "Expense Leakage Reduced" },
    { text: "Excellent support team from Yashvitech. They migrated all our old data seamlessly. The software works smoothly on mobile browsers so our branch managers can create bilty anywhere.", name: "Anil Sharma", role: "Operations Head, Apex Freight Movers", company: "Pan India Operations", image: "https://images.unsplash.com/photo-1568602471122-7832951cc4c5?auto=format&fit=crop&w=500&q=80", result: "Easy Mobile & Branch Operations", number: "3x", label: "Faster Bilty Processing" },
  ];

  return (
    <section className="yt-tms-success-section" id="stories">
      <div className="yt-tms-success-top">
        <span className="yt-tms-success-badge">★ CLIENT SUCCESS STORIES</span>
        <h1>Trusted by Transporters.<br /><span>Loved by Fleet Owners.</span></h1>
        <p className="yt-tms-success-description">From growing transport companies to large fleet operators, Yashvitech TMS helps businesses simplify operations, control expenses and increase profitability.</p>
      </div>

      <div className="yt-tms-success-highlights">
        <div className="yt-tms-success-highlight"><strong>500+</strong><span>Transport Businesses</span></div>
        <div className="yt-tms-success-highlight"><strong>10M+</strong><span>Bilties Generated</span></div>
        <div className="yt-tms-success-highlight"><strong>4.9/5</strong><span>Customer Satisfaction</span></div>
        <div className="yt-tms-success-highlight"><strong>99.9%</strong><span>System Uptime</span></div>
      </div>

      <div className="yt-tms-review-heading">
        <span className="yt-tms-review-label">REAL CUSTOMERS • REAL RESULTS</span>
        <h2>See the Impact of Yashvitech TMS</h2>
        <p>Transport businesses are saving time, reducing operational leakage and making smarter decisions every day.</p>
      </div>

      <div className="yt-tms-success-cards">
        {reviews.map((review, index) => (
          <div className="yt-tms-success-card" key={index}>
            <div className="yt-tms-success-card-top">
              <div className="yt-tms-stars">★★★★★</div>
              <span className="yt-tms-verified-review">✓ Verified Customer</span>
            </div>
            <p className="yt-tms-review-text">"{review.text}"</p>
            <div className="yt-tms-review-result">
              <span className="yt-tms-impact-label">BUSINESS IMPACT</span>
              <strong>{review.result}</strong>
            </div>
            <div className="yt-tms-review-performance">
              <div><strong>{review.number}</strong><span>{review.label}</span></div>
              <span className="yt-tms-performance-icon">↗</span>
            </div>
            <div className="yt-tms-review-person">
              <div className="yt-tms-review-image"><img src={review.image} alt={review.name} /></div>
              <div className="yt-tms-review-person-info">
                <h4>{review.name}</h4>
                <p>{review.role}</p>
                <span>🚚 {review.company}</span>
              </div>
              <div className="yt-tms-customer-check">✓</div>
            </div>
          </div>
        ))}
      </div>

      <div className="yt-tms-success-trust">
        <span>✓ Secure Cloud Platform</span>
        <span>✓ Dedicated Support</span>
        <span>✓ Easy Data Migration</span>
        <span>✓ Mobile Friendly</span>
      </div>

      <div className="yt-tms-success-bottom">
        <div className="yt-tms-success-bottom-content">
          <span className="yt-tms-join-tag">JOIN 500+ TRANSPORT BUSINESSES</span>
          <h2>Ready to make your transport<br />business more profitable?</h2>
          <p>Discover how Yashvitech TMS can simplify your billing, dispatch, fleet management and reporting.</p>
        </div>
        <a href="#Book" className="yt-tms-success-demo-btn">Book Free Demo <span>→</span></a>
      </div>
    </section>
  );
}

// ================= FAQ =================
function Faq() {
  const [openIndex, setOpenIndex] = useState(null);
  const toggle = (index) => setOpenIndex(openIndex === index ? null : index);

  const questions = [
    { q: "What is Transport Management System (TMS) software?", a: "A TMS is a cloud platform that helps transporters manage bilty generation, fleet dispatch, driver documents, diesel expenses and profit tracking in one place." },
    { q: "Can I access Yashvitech TMS on mobile phones or tablets?", a: "Yes, Yashvitech TMS works smoothly on any mobile browser so branch managers and drivers can use it on the go." },
    { q: "How does the Driver DL and Vehicle Permit alert system work?", a: "The system automatically tracks driver license and vehicle permit expiry dates and sends alerts before they expire, helping avoid RTO fines." },
    { q: "Can Yashvitech TMS generate Truck Profit and Loss reports?", a: "Yes, you can view route-wise and truck-wise profit and loss reports including diesel, tyre and maintenance costs." },
  ];

  return (
    <section className="yt-tms-faq-section" id="faq">
      <div className="yt-tms-faq-top">
        <span className="yt-tms-faq-tag">GOT QUESTIONS?</span>
        <h1>Frequently Asked Questions<span> About Yashvitech TMS</span></h1>
        <p className="yt-tms-faq-sub">Everything you need to know about managing your transport operations, fleet, expenses and profitability with Yashvitech TMS.</p>
      </div>

      <div className="yt-tms-faq-main">
        <div className="yt-tms-faq-image-area">
          <div className="yt-tms-faq-image-box">
            <img src="https://images.unsplash.com/photo-1519003722824-194d4455a60c?auto=format&fit=crop&w=1200&q=85" alt="Transport Management" />
            <div className="yt-tms-faq-image-content">
              <span>YASHVITECH TMS</span>
              <h2>Run Your Transport<br />Business Smarter.</h2>
              <p>Manage vehicles, drivers, bilty, diesel, documents and profits from one powerful platform.</p>
            </div>
          </div>
          <div className="yt-tms-faq-stat-card"><strong>24/7</strong><span>Business<br />Visibility</span></div>
          <div className="yt-tms-faq-live-card">
            <span className="yt-tms-live-dot"></span>
            <div><strong>TMS Dashboard</strong><small>Operations running smoothly</small></div>
          </div>
        </div>

        <div className="yt-tms-faq-content">
          <div className="yt-tms-faq-content-title">
            <span>TRANSPORT SOFTWARE FAQ</span>
            <h2>Simple answers.<br />Powerful solutions.</h2>
          </div>

          <div className="yt-tms-faq-list">
            {questions.map((item, index) => (
              <div className={`yt-tms-faq-item ${openIndex === index ? "yt-tms-faq-active" : ""}`} key={index}>
                <div className="yt-tms-faq-question" onClick={() => toggle(index)}>
                  <span className="yt-tms-faq-number">0{index + 1}</span>
                  <h3>{item.q}</h3>
                  <span className="yt-tms-faq-icon">{openIndex === index ? "−" : "+"}</span>
                </div>
                {openIndex === index && <p className="yt-tms-faq-answer">{item.a}</p>}
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="yt-tms-faq-features">
        <div className="yt-tms-faq-feature-card"><span className="yt-tms-faq-feature-icon">🚛</span><div><h3>Fleet Management</h3><p>Keep complete control over vehicles, drivers and daily dispatch operations.</p></div></div>
        <div className="yt-tms-faq-feature-card"><span className="yt-tms-faq-feature-icon">₹</span><div><h3>Expense Management</h3><p>Track diesel, tyre, maintenance and other running expenses in one place.</p></div></div>
        <div className="yt-tms-faq-feature-card"><span className="yt-tms-faq-feature-icon">📊</span><div><h3>Business Analytics</h3><p>Get clear truck-wise and route-wise profit and loss insights.</p></div></div>
      </div>

      <div className="yt-tms-faq-bottom">
        <div>
          <span>NEED MORE INFORMATION?</span>
          <h2>Ready to simplify your<br />transport operations?</h2>
          <p>See how Yashvitech TMS can help you manage your complete transport business from one place.</p>
        </div>
        <button onClick={() => document.getElementById("demo")?.scrollIntoView({ behavior: "smooth" })}>Explore TMS <span>→</span></button>
      </div>
    </section>
  );
}

// ================= DEMO FORM =================
function DemoForm() {
  const [formData, setFormData] = useState({
    name: "", company: "", phone: "", email: "",
    fleet: "1 to 10 Trucks", challenge: "Automating Bilty & Billing",
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleDemoSubmit = async (e) => {
    e.preventDefault();

    // Validation — email ya phone mein se ek zaroori
    if (!formData.email.trim() && !formData.phone.trim()) {
      toast.error("Please enter either Email or Phone number.");
      return;
    }

    setLoading(true);
    try {
      const result = await submitProductEnquiry({
        name: formData.name,
        email: formData.email || "",
        phone: formData.phone,
        company: formData.company,
        product: "TMS",
        message: `Fleet: ${formData.fleet} | Challenge: ${formData.challenge}`,
      });

      if (result.status === "success") {
        // ✅ Toast with name
        toast.success(
          `Congratulations ${formData.name}! Your form is submitted successfully. We will respond to you as soon as possible.`,
          { duration: 5000 }
        );
        setFormData({ name: "", company: "", phone: "", email: "", fleet: "1 to 10 Trucks", challenge: "Automating Bilty & Billing" });
      } else {
        toast.error("Something went wrong. Please try again.");
      }
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="yt-tms-demo-form-section" id="Book">
      <div className="yt-tms-demo-left">
        <span className="yt-tms-demo-tag">FREE PERSONALIZED DEMO</span>
        <h1>Ready to Automate Your Logistics & Multiply Fleet Profits?</h1>
        <p>Schedule a 15-minute live demo with our Transport Management System specialists. We will show you how Yashvitech TMS can fit your exact fleet size and business workflow.</p>
        <p>✔ Zero Setup Fee & Custom Onboarding Assistance</p>
        <p>✔ Instant Data Import from Excel / Tally</p>
        <p>✔ Dedicated Account Manager & 24/7 Support</p>
        <p>Prefer to speak directly with us?</p>
        <h3>Call Sales: +91 98765 43210</h3>
      </div>

      <div className="yt-tms-demo-right">
        <h2>Request Your Free TMS Demo</h2>
        <p>Fill in your details below. Our team will contact you within 15 minutes.</p>

        <form onSubmit={handleDemoSubmit}>
          <label>Full Name *</label>
          <input type="text" name="name" placeholder="e.g. Ramesh Shah" required value={formData.name} onChange={handleChange} />

          <label>Company / Firm Name *</label>
          <input type="text" name="company" placeholder="e.g. Shah Transporters" required value={formData.company} onChange={handleChange} />

          <label>Phone Number (WhatsApp)</label>
          <input type="text" name="phone" placeholder="+91 98765 43210" value={formData.phone} onChange={handleChange} />

          <label>Business Email</label>
          <input type="email" name="email" placeholder="ramesh@shahtrans.com" value={formData.email} onChange={handleChange} />

          <label>Fleet Size (Number of Vehicles)</label>
          <select name="fleet" value={formData.fleet} onChange={handleChange}>
            <option>1 to 10 Trucks</option>
            <option>11 to 30 Trucks</option>
            <option>31 to 100 Trucks</option>
            <option>100+ Trucks</option>
          </select>

          <label>Primary Challenge</label>
          <select name="challenge" value={formData.challenge} onChange={handleChange}>
            <option>Automating Bilty & Billing</option>
            <option>Fleet Tracking</option>
            <option>Driver Management</option>
            <option>Diesel & Expense Control</option>
          </select>

          <button type="submit" className="yt-tms-submit-btn" disabled={loading}>
            {loading ? "Submitting..." : "Submit & Book My Demo →"}
          </button>
        </form>

        <p className="yt-tms-privacy-text">🔒 We respect your privacy. No spam guaranteed.</p>
      </div>
    </section>
  );
}

// ================= FOOTER =================
function Footer() {
  return (
    <footer className="yt-tms-footer-section">
      <div className="yt-tms-footer-columns">
        <div className="yt-tms-footer-about">
          <div className="yt-tms-footer-logo">
            <div className="yt-tms-logo-box"><img src="https://www.yashvitech.com/static/media/logo(b).c451bf22349ad8c51a6c.png" alt="Yashvitech Logo" /></div>
          </div>
          <p>Yashvitech is a pioneer in web-based transport management solutions, empowering goods transport companies, fleet owners, and dispatchers across India with cutting-edge cloud automation.</p>
          <div className="yt-tms-footer-socials"><span>🌐</span><span>in</span><span>f</span></div>
        </div>

        <div className="yt-tms-footer-links">
          <h3>TMS Modules</h3>
          <p>Bilty / LR Generator</p>
          <p>Truck Dispatch Tracker</p>
          <p>Diesel & Tyre Logs</p>
          <p>Permit & DL Alerts</p>
          <p>Daily Cashbook Log</p>
        </div>

        <div className="yt-tms-footer-links">
          <h3>Reports & Accounts</h3>
          <p>Truck Profit & Loss</p>
          <p>Party Ledger & Billing</p>
          <p>Driver Payroll & Book</p>
          <p>Consignee Directory</p>
          <p>Inventory Reports</p>
        </div>

        <div className="yt-tms-footer-contact">
          <h3>Contact Yashvitech</h3>
          <p>📍 Yashvitech Tech Park, Logistics Wing, India</p>
          <p>✉ info@yashvitech.com</p>
          <p>🌐 www.yashvitech.com</p>
        </div>
      </div>

      <hr />

      <div className="yt-tms-footer-bottom">
        <p>© 2026 Yashvitech Technologies. All rights reserved. Transport Management System (TMS).</p>
        <div className="yt-tms-footer-bottom-links">
          <span>Privacy Policy</span><span>Terms of Service</span><span>Security</span>
        </div>
      </div>
    </footer>
  );
}

// ================= MAIN APP =================
function App() {
  return (
    <div className="yt-tms-page-wrapper">
      <Toaster
        position="top-right"
        toastOptions={{ duration: 5000, style: { fontSize: "13px", borderRadius: "10px", maxWidth: "380px" } }}
      />
      <Header />
      <Home />
      <Features />
      <InteractiveDemo />
      <SuccessStories />
      <Faq />
      <DemoForm />
      <Footer />
    </div>
  );
}

export default App;